import React from 'react'

export default function MetronomeIcon({ metronome, isPlaying, handleMetronomeTick }) {
  return (
    <div style={{display: 'flex', width: '40px', height: '40px', flexWrap: 'wrap', gap: '2px', cursor: 'pointer'}} onClick={handleMetronomeTick}>
        <div style={{width: '18px', height: '18px', borderTopLeftRadius: '2px',backgroundColor: !isPlaying? '#DFDBCE' : metronome === 0? 'var(--clr_purple)' : '#DFDBCE'}}></div>
        <div style={{width: '18px', height: '18px', borderTopRightRadius: '2px',backgroundColor: !isPlaying? '#DFDBCE' : metronome === 1? 'var(--clr_purple)' : '#DFDBCE'}}></div>
        <div style={{width: '18px', height: '18px', borderBottomLeftRadius: '2px',backgroundColor: !isPlaying? '#DFDBCE' : metronome === 3? 'var(--clr_purple)' : '#DFDBCE'}}></div>
        <div style={{width: '18px', height: '18px', borderBottomRightRadius: '2px',backgroundColor: !isPlaying? '#DFDBCE' : metronome === 2? 'var(--clr_purple)' : '#DFDBCE'}}></div>
    </div>
  )
}


/*<div>
        {metronome?
            <svg width="50" height="53" viewBox="0 0 50 53" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M38.243 48.9999H11.757C10.397 48.9999 9.43364 47.6719 9.85577 46.3791L21.1976 11.6449C22.3985 7.96704 27.6015 7.96705 28.8024 11.6449L40.1442 46.3791C40.5664 47.6719 39.603 48.9999 38.243 48.9999Z" fill={"var(--clr_purple)"}/>
                <path d="M24.2931 41.7077C24.6836 42.0982 25.3168 42.0982 25.7073 41.7077C26.0979 41.3172 26.0979 40.684 25.7073 40.2935L24.2931 41.7077ZM25.7073 40.2935L12.9793 27.5655L11.5651 28.9797L24.2931 41.7077L25.7073 40.2935Z" fill={"var(--clr_purple)"}/>
                <circle cx="9.44378" cy="25.4442" r="6" transform="rotate(-45 9.44378 25.4442)" fill={"var(--clr_purple)"}/>
            </svg>
            
        :
            <svg width="50" height="53" viewBox="0 0 50 53" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M38.243 48.9999H11.757C10.397 48.9999 9.43364 47.6719 9.85577 46.3791L21.1976 11.6449C22.3985 7.96704 27.6015 7.96705 28.8024 11.6449L40.1442 46.3791C40.5664 47.6719 39.603 48.9999 38.243 48.9999Z" fill={"var(--clr_purple)"}/>
                <path d="M24.2932 40.2935C23.9026 40.6841 23.9026 41.3172 24.2932 41.7078C24.6837 42.0983 25.3168 42.0983 25.7074 41.7078L24.2932 40.2935ZM25.7074 41.7078L38.4354 28.9798L37.0212 27.5655L24.2932 40.2935L25.7074 41.7078Z" fill={"var(--clr_purple)"}/>
                <circle cx="40.5566" cy="25.4442" r="6" transform="rotate(45 40.5566 25.4442)" fill={"var(--clr_purple)"}/>
            </svg>       
        }
    </div>*/

    /*return (
        <div style={{ width: "1rem", height: "1rem", backgroundColor: metronome === 0? 'var(--clr_yellow)' : metronome === 1? 'var(--clr_red)' :  metronome === 2? 'var(--clr_green)' : metronome === 3? 'var(--clr_blue)' : 'var(--clr_yellow)'  }}>
    
        </div>
      )*/